export enum FUNCTION_NAME_ENUM {
  SET_VALUE = 'setValue',
  NULLIFY = 'nullify',
  MASK = 'mask',
  HASH = 'hash',
}
